import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {BasicMenu} from "types/BasicMenu"

interface ArgsProps {
    title: string
    text: string
}

type ReturnedType = {
    status: "success"
    menu: BasicMenu
}

/**
 * Создание меню
 */
export const createBasicMenu = createAsyncThunk<ReturnedType, ArgsProps, AppThunkProps>(
    "basic-menu/create",
    async (data, {signal}) => {
        return api.post<ReturnedType>("/user/basic-menu", data, {signal})
    }
)
